import React, { useState } from 'react';
import '../../styles/APSIS.css';

export default function APSISRegistration() {
  const [formData, setFormData] = useState({
    company: '',
    activity: '',
    email: '',
    phone: ''
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log("APSIS Registration Submitted:", formData);
    alert("Votre inscription a été envoyée avec succès.");
    setFormData({ company: '', activity: '', email: '', phone: '' });
  };

  return (
    <div className="apsis-registration-page">
      <div className="apsis-hero registration-hero">
         <div className="apsis-hero-content">
            <span className="apsis-tag">INSCRIPTION & DOCUMENTATION</span>
            <h1>REJOINDRE APSIS 2026</h1>
            <p>Accédez aux dossiers officiels et soumettez votre demande de participation.</p>
         </div>
      </div>

      <div className="apsis-content-grid">
        
        {/* A4 PDF Sector */}
        <section className="apsis-pdf-section">
           <div className="section-header-v2">
              <span className="accent-line"></span>
              <h2>DOCUMENTATION OFFICIELLE</h2>
           </div>
           
           <div className="pdf-preview-v2" onClick={() => window.open('https://www.w3.org/WAI/ER/tests/xhtml/testfiles/resources/pdf/dummy.pdf', '_blank')}>
         
           </div>
        </section>

        {/* Global Inscription Form */}
        <section className="apsis-form-section">
           <div className="section-header-v2">
              <span className="accent-line"></span>
              <h2 style={{color: 'white'}}>FORMULAIRE D'INSCRIPTION</h2>
           </div>
           <p>Veuillez renseigner les informations de votre organisation ci-dessous. Notre équipe stratégique vous contactera dans les meilleurs délais.</p>

           <form className="apsis-form" onSubmit={handleSubmit}>
              <div className="form-group-full">
                 <input 
                   type="text" 
                   name="company" 
                   value={formData.company} 
                   onChange={handleChange} 
                   placeholder="NOM DE LA COMPAGNIE / ORGANISATION" 
                   className="apsis-input" 
                   required 
                 />
              </div>

              <div className="form-group-full">
                 <input 
                   type="text" 
                   name="activity" 
                   value={formData.activity} 
                   onChange={handleChange} 
                   placeholder="SECTEUR D'ACTIVITÉ (SÉCURITÉ, TECH, DÉFENSE...)" 
                   className="apsis-input" 
                   required 
                 />
              </div>

              <div className="input-group">
                 <input 
                   type="email" 
                   name="email" 
                   value={formData.email} 
                   onChange={handleChange} 
                   placeholder="ADRESSE EMAIL PROFESSIONNELLE" 
                   className="apsis-input" 
                   required 
                 />
              </div>

              <div className="input-group">
                 <input 
                   type="tel" 
                   name="phone" 
                   value={formData.phone} 
                   onChange={handleChange} 
                   placeholder="COORDONNÉES TÉLÉPHONIQUES" 
                   className="apsis-input" 
                   required 
                 />
              </div>

              <button type="submit" className="apsis-submit">
                SOUMETTRE MON DOSSIER D'INSCRIPTION
              </button>
           </form>
        </section>

      </div>
    </div>
  );
}
